import * as React from 'react';
import { observer } from 'mobx-react';
import { Navbar, Nav, NavDropdown, MenuItem, NavItem, Glyphicon } from 'react-bootstrap';
import { observable } from 'mobx';

import { inject, bind } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';
import { ApiStore } from '../../stores/ApiStore';
import FaIcon from './FaIcon';
import UserDisplayName from '../user/UserDisplayName';

class NavDivider extends React.Component<{}, {}> {
  render() {
    return <li className="divider-vertical" />;
  }
}

@observer
export default class TopBar extends React.Component<{}, {}> {

  @observable userDisplayName: string = '';
  @inject(UiStore) uiStore: UiStore;
  @inject(ApiStore) apiStore: ApiStore;

  @bind async handleLogoutClick() {
    await this.uiStore.logout();
    this.uiStore.navigateTo('/login');
  }

  render() {
    return (
      this.uiStore.isLoggedIn ? (
        <Navbar className="navbar" inverse={true} collapseOnSelect={true} default={true} staticTop={true}>
          <Navbar.Toggle />
          <Navbar.Collapse>
          <Nav style={{marginLeft: '-10px'}}>
            <NavDivider/>
            <NavItem
              eventKey={1}
              className="nav-auftraege"
              onClick={() => this.uiStore.navigateTo('/auftraege')}
            >
              <Glyphicon glyph="list" style={{ color: '#008ac1' }} /> Aufträge
            </NavItem>
            <NavDivider/>
            {this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
              <NavItem
                eventKey={2}
                className="nav-auftraege"
                onClick={() => this.uiStore.navigateTo('/auftraege/lizenz')}
              >
                <FaIcon icon="folder-open" /> Aufträge (Lizenz)
              </NavItem>
            }
            {this.uiStore.userProfile && this.uiStore.userProfile.projektleiter &&
              <NavDivider/>
            }
            <NavItem
              eventKey={3}
              className="nav-auftraege"
              onClick={() => this.uiStore.navigateTo(`/auftrag/neu`)}
            >
              <Glyphicon glyph="plus" style={{ color: '#5cb85c' }} /> Neuer Auftrag
            </NavItem>
            <NavDivider/>
          </Nav>

          <Nav pullRight={true}>
            <NavDropdown
              // tslint:disable-next-line:no-any
              title={<UserDisplayName /> as any}
              id="usermenu"
            >
              <MenuItem onClick={() => this.uiStore.navigateTo('/profile')} >
                <FaIcon icon="gear" /> Meine Daten
                </MenuItem>
              <MenuItem divider={true} />
              <MenuItem onClick={() => this.uiStore.navigateTo('/arbeitsmittel')} >
                <FaIcon icon="briefcase" /> Meine Arbeitsmittel
                </MenuItem>
              <MenuItem divider={true} />
              {/* @todo: Vorerst nach Rücksprache mit DIQ Zert entfernt - 2026-02-11 swillems */}
              {/* <MenuItem onClick={() => this.uiStore.navigateTo('/belege')} >
                <FaIcon icon="eur" /> Belege
              </MenuItem>
              <MenuItem divider={true} /> */}
              <MenuItem onClick={() => this.uiStore.navigateTo('/qm')} >
                <FaIcon icon="file-text-o" /> QM-Dokumentation
                </MenuItem>
              <MenuItem divider={true} />
              <MenuItem onClick={() => this.uiStore.navigateTo('/kontakt')} >
                <FaIcon icon="phone" /> Kontakt
                </MenuItem>
              <MenuItem divider={true} />
              <MenuItem onClick={() => this.uiStore.navigateTo('/portal')} >
                <FaIcon icon="info" /> Über das Portal
                </MenuItem>
              <MenuItem divider={true} />
              <MenuItem onClick={this.handleLogoutClick}>
                <FaIcon icon="sign-out" /> Logout
                </MenuItem>
            </NavDropdown>
          </Nav>
          </Navbar.Collapse>
        </Navbar>
        ) : <div />
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/TopBar.tsx